import script from "./Kagi.vue?vue&type=script&lang=js"
export * from "./Kagi.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__